import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faStethoscope, faUserMd, faSyringe, faHands } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'; // For navigation


const Health: React.FC = () => {
  const navigate = useNavigate(); // Hook for navigation

  const handleDonateClick = () => {
    navigate('/donate');
  };

  return (
    <div className="health-page">
      {/* Section 1: Hero Section with Background Image and Overlay */}
      <div className="hero-section" style={{ backgroundImage: `url('https://i.pinimg.com/736x/19/fe/8c/19fe8cd10b80ea0da677519dfbbb52ac.jpg')` }}>
        <div className="overlay">
          <Container className="text-center py-5">
            <h1 className="hero-title">Promoting Health for All</h1>
            <p className="hero-subtitle">Ensuring that healthcare and wellness are accessible to every individual, regardless of background.</p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Container>
        </div>
      </div>

      {/* Section 2: Our Mission */}
      <Container className="my-5">
        <Row className="align-items-center">
          <Col md={6}>
            <img
              src="https://i.pinimg.com/736x/df/11/61/df1161b319ce6046724965b580c5f23f.jpg"
              alt="Healthcare Workers"
              className="img-fluid"
            />
          </Col>
          <Col md={6}>
            <h2 className="section-title"><FontAwesomeIcon icon={faHeart} className="me-2" /> Our Mission</h2>
            <p className="section-text">
              At Srisailam Foundation, we are dedicated to improving health outcomes by offering medical care, health education, and essential support to underserved communities across India.
            </p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Section 3: Healthcare Services */}
      <Container className="my-5 py-5" style={{ backgroundColor: '#F3F4F6' }}>
        <h2 className="text-center section-title mb-5"><FontAwesomeIcon icon={faStethoscope} className="me-2" /> Healthcare Services</h2>
        <Row className="g-4">
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://i.pinimg.com/736x/d2/16/c0/d216c0133a4f60db4032252ceaefa175.jpg" alt="Medical Camps" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Medical Camps</Card.Title>
                <Card.Text className="card-text">
                  Providing free health check-ups and treatments in remote areas to ensure access to essential healthcare.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1hQeuMqM9NGXckwdqYWYA3tsv5VeaxuJkrA&s" alt="Vaccination Drives" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Vaccination Drives</Card.Title>
                <Card.Text className="card-text">
                  Facilitating widespread immunization to prevent diseases and protect communities.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://i.pinimg.com/736x/2a/73/8c/2a738ce3796f0084987844cd6eda309d.jpg" alt="Maternal Care" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Maternal Care</Card.Title>
                <Card.Text className="card-text">
                  Providing comprehensive prenatal and postnatal care to ensure the health and well-being of mothers and their babies.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Section 4: Wellness Programs */}
      <Container className="my-5">
        <Row className="align-items-center flex-row-reverse">
          <Col md={6}>
            <img
              src="https://i.pinimg.com/736x/01/4d/86/014d86693e10083cd67c024e48e23485.jpg"
              alt="Fitness Program"
              className="img-fluid "
            />
          </Col>
          <Col md={6}>
            <h2 className="section-title"><FontAwesomeIcon icon={faUserMd} className="me-2" /> Wellness Programs</h2>
            <p className="section-text">
              Providing nutrition workshops, mental health support, and fitness initiatives to foster holistic well-being.
            </p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Section 5: Community Health */}
      <Container className="my-5 py-5" style={{ backgroundColor: '#E5E7EB' }}>
        <h2 className="text-center section-title mb-5"><FontAwesomeIcon icon={faSyringe} className="me-2" /> Community Health</h2>
        <Row className="g-4">
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://i.pinimg.com/736x/48/a7/27/48a727ef02027e6e43c568e0d5e03989.jpg" alt="Health Education" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Health Education</Card.Title>
                <Card.Text className="card-text">
                  Promoting awareness on hygiene, disease prevention, and healthy living practices to improve community well-being.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://i.pinimg.com/736x/85/d1/6d/85d16d00f62dd8dfdb2a4593d3e57ead.jpg" alt="Emergency Relief" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Emergency Relief</Card.Title>
                <Card.Text className="card-text">
                  Delivering swift medical aid and support during crises and natural disasters to save lives and provide essential care.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Section 6: Call to Action */}
      <Container className="my-5 text-center py-5" style={{ backgroundColor: 'gray', color: '#FFFFFF' }}>
        <h2 className="section-title mb-4 text-white">Support a Healthier Tomorrow</h2>
        <p className="section-text mb-4 text-white">
          Your donation can save lives and improve health outcomes across communities. Join us today to make a lasting impact!
        </p>
        <Button className="donate-btn" size="lg" onClick={handleDonateClick}>
          Donate Us
        </Button>
      </Container>
    </div>
  );
};

export default Health;